<script setup lang="ts">
defineProps({
  title: { type: String, required: true },
  eyebrow: { type: String, required: true },
  sectionLink: { type: String, required: true },
  imageLink: { type: String, required: true },
})
const localePath = useLocalePath()
</script>

<template>
  <nuxt-link :to="localePath(sectionLink)">
    <div class="w-80 sm:w-96 flex flex-col items-center cursor-pointer group">
      <img
        class="w-full mb-10 grayscale group-hover:filter-none transition-all"
        :src="imageLink"
        :alt="eyebrow"
      />
      <span class="font-medium text-[#6B7280] uppercase text-base mb-2">
        {{ eyebrow }}
      </span>
      <h2 class="text-3xl text-center">
        {{ title }}
      </h2>
      <span class="text-primary-darkish font-bold py-3 flex items-center mt-4">
        {{ $t('common.see_how_it_works') }}
        <i class="gg-arrow-long-right ml-4"></i>
      </span>
    </div>
  </nuxt-link>
</template>
